"use strict";

const BaseEnforcementController = require("../../enforcement/baseEnforcementController");

const ProjectEnforcementController = function () {
  const formKey = "project-enforcement";
  const htmlPath = "modals/newProjectEnforcement";
  const headerTemplate = "modals/newProjectInspection/projectInspectionHeader.njk";

  const getTabModules = () => {
    return {
      EnforcementAction: require("./enforcementAction"),
      EnforcementLetterManagement: require("./enforcementLetterManagement"),
      EnforcementHistory: require("./enforcementHistory"),
    };
  };

  const newEnforcementApiFunction = (projectId) => ApiCalls.getProjectForNewEnforcement(projectId);
  const getEnforcementApiFunction = (enforcementId) =>
    ApiCalls.getProjectEnforcement(enforcementId);
  const createEnforcementApiFunction = (formData) => ApiCalls.issueProjectEnforcement(formData);
  const updateEnforcementApiFunction = (formData) => ApiCalls.updateProjectEnforcement(formData);

  const getAssetNameFunction = (data) => data.project.projectName;
  const getAssetIdFunction = (data) => {
    return { projectId: data.project.id };
  };

  const afterHideFunction = () => {
    ConstructionProjectGeoServerLayer.invalidateLayerData();
    ToDoListController.loadTodos();
  };

  const base = BaseEnforcementController(
    formKey,
    htmlPath,
    headerTemplate,
    getTabModules,
    newEnforcementApiFunction,
    getEnforcementApiFunction,
    createEnforcementApiFunction,
    updateEnforcementApiFunction,
    getAssetNameFunction,
    getAssetIdFunction,
    { afterHideFunction },
  );

  return {
    ...base,
  };
};

module.exports = ProjectEnforcementController();

const ConstructionProjectGeoServerLayer = require("../../constructionG2/constructionProjectGeoServerLayer");
const ApiCalls = require("../../apiCalls");
const ToDoListController = require("../../mapFunctions/toDoListController");
